import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import AiGenerativeCleanupIcon from '@atlaskit/icon-lab/core/ai-generative-cleanup';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactory,
	EditorPluginAIConfigItemWithOptionsFactory,
} from '../../config-items';

export const addPolish: EditorPluginAIConfigItemFactory = (options) => ({
	key: CONFIG_ITEM_KEYS.ADD_POLISH,
	title: expValEquals('platform_editor_ai_rename_add_polish', 'isEnabled', true)
		? aiConfigItemMessages.improveFormattingTitle
		: aiConfigItemMessages.addPolishTitle,
	description: aiConfigItemMessages.addPolishDescription,
	icon: () => <AiGenerativeCleanupIcon label="" />,
	showInRefineDropdown: true,
	/**
	 * Polish prompt doesn't exist in assistance-service, so using shorten_intent_schema.json.
	 * Once migration to convo-ai is complete, we will remove intentShemaId option.
	 */
	intentSchemaId: 'shorten_intent_schema.json',
	featureId: 'add_polish_adf',
	adfPrompt: true,
	requiresTextualContent: true,
	actions: {
		empty: [
			createInsertBelow({
				appearance: 'secondary',
				factoryOptions: options,
			}),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({
				appearance: 'secondary',
				factoryOptions: options,
			}),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});

export const addPolishWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: addPolish(),
	triggers: {
		empty: {
			enabled: options?.isInDocumentStreamingEnabled ?? false,
			docMinSize: 1,
		},
		selection: {
			enabled: options?.isInDocumentStreamingEnabled ?? false,
			selectionMinSize: 1,
		},
	},
});
